module.exports = {"150625100":"锡尼镇","150625101":"巴拉贡镇","150625102":"吉日嘎朗图镇","150625103":"独贵塔拉镇","150625104":"呼和木独镇","150625200":"伊和乌素苏木","150625400":"内蒙古鄂尔多斯杭锦经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150625.json
// module id = 530
// module chunks = 0